function looksLikeHtml(value) {
    return value.startsWith('<') || value.startsWith('<!')
}

/**
 * TENANT_EMAIL_GET may return body as plain HTML (prod API) or base64
 * (DynamoDB / legacy mocks). Detect which and return decoded HTML.
 */
export function decodeEmailTemplateBody(body) {
    if (!body) return ''

    const trimmed = body.trim()
    if (looksLikeHtml(trimmed)) {
        return body
    }

    try {
        const decoded = decodeURIComponent(escape(window.atob(trimmed)))
        if (looksLikeHtml(decoded.trim())) {
            return decoded
        }
    } catch {
        // Not valid base64 — return as-is.
    }

    return body
}

export function encodeEmailTemplateBody(html) {
    return window.btoa(unescape(encodeURIComponent(html)))
}
